module.exports = __webpack_public_path__ + "img/close-menu.7df7fe39.svg";